module.exports = __webpack_public_path__ + "static/media/account_white.558c0331.svg";